import { RotateCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useMensalidades } from '@/context/MensalidadesContext';

/** Botao recarregar no header — chama reload() do hook. */
export function ReloadButton() {
  const { reload, state } = useMensalidades();
  const { t } = useTranslation();
  const loading = state.status === 'loading';

  return (
    <button
      type="button"
      className="aiobi-icon-btn"
      onClick={reload}
      disabled={loading}
      title={t('header.reload')}
      aria-label={t('header.reload')}
    >
      <RotateCw size={14} className={loading ? 'aiobi-spin' : undefined} />
      <span>{t('header.reload')}</span>
    </button>
  );
}
